/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { Avatar, Checkbox, Tooltip } from 'antd';
import { isEmpty, findIndex } from 'lodash';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheckCircle, faShieldCheck } from '@fortawesome/pro-light-svg-icons';
import { getKeyValue } from 'Src/common/utilities/data_util';
import { arrayOf, bool, number, shape, string } from 'prop-types';
import ThemeXModal from '../../themeXModal/index';

/**
 * Profile List Item Component
 */
export default function ProfileListItem({
  record,
  isSelected,
  isVFXEnabled,
  selectedItems,
  isActionEnabled,
  disableSelectedItems,
  isMultipleSelectionEnabled,
  onlyAllowUserWithEmailAddress,
}) {
  const [openVFXModal, setOpenVFXModal] = useState(false);

  function toggleVFXModal(e) {
    if (e?.stopPropagation) e.stopPropagation();
    setOpenVFXModal(!openVFXModal);
  }

  /**
   *
   * @param {array} educations
   * @param {string} role
   * This function will generate the extra string from education and role of the record
   */
  function getProfileCardExtraDetails(educations, role) {
    if (educations) {
      const classYear = getKeyValue(educations, '0__class_year', '');
      return `${classYear && `Class of ${classYear}`}${role && ` - ${role}`}`;
    }
    return '';
  }

  /**
   * This function will return the subtitle
   */
  function getSubtitleForRecordGroups() {
    const { groups } = record;
    // eslint-disable-next-line array-callback-return
    const smallSubtitle =
      groups
        .slice(0, 2)
        .map((obj) => obj.name)
        .join(',') || '';
    return (
      <span>
        {smallSubtitle}
        {record.groups.length > 2 && (
          <span onClick={toggleVFXModal} role="button" className="arc-color-primary">
            {` and ${record.groups.length - 2} more`}
          </span>
        )}
      </span>
    );
  }

  const verifications = record.groups ? record.groups.map((obj) => obj.name).join(', ') : '';

  return (
    <div className="mapper-profile-list-item">
      <div className="mapper-profile-left-content">
        <Avatar
          src={getKeyValue(record, 'present_picture')}
          shape="circle"
          size="large"
          alt="Av"
          style={{ minWidth: 40 }}
        />
        <div className="mapper-profile-item-content">
          <p
            className="mapper-profile-item-title arc-cursor-p
            arc-H150 arc-color-B65 arc-font-weight-medium"
            role="presentation">
            {getKeyValue(record, 'formatted_name', '')}
            <If condition={!isVFXEnabled}>
              <span>
                {record.is_registered && <FontAwesomeIcon className="arc-color-primary ml8" icon={faCheckCircle} />}
              </span>
            </If>
          </p>
          <Choose>
            <When condition={isVFXEnabled}>
              <p className="mapper-profile-item-extra arc-support arc-color-B55 mt1">
                <Choose>
                  <When condition={!isEmpty(record.groups)}>
                    <FontAwesomeIcon className="arc-color-primary mr4 ml2" icon={faShieldCheck} />
                    {getSubtitleForRecordGroups()}
                  </When>
                  <Otherwise>
                    <span className="arc-color-B55 arc-support">No verifications on record</span>
                  </Otherwise>
                </Choose>
              </p>
            </When>
            <Otherwise>
              <p className="mapper-profile-item-extra mt1">
                <span className="arc-color-B55 arc-support">
                  {getProfileCardExtraDetails(record.educations, record.role)}
                </span>
              </p>
            </Otherwise>
          </Choose>
          <p className="arc-color-B55 arc-support">
            System Record Id: {getKeyValue(record, 'external_database_id', '-')}
          </p>
          <p className="arc-color-B55 arc-support">
            Constituent Id: {getKeyValue(record, 'external_database_lookup_id', '-')}
          </p>
        </div>
      </div>
      <If condition={isActionEnabled}>
        <Choose>
          <When condition={isMultipleSelectionEnabled}>
            <div className="mapper-profile-right-content">
              <Choose>
                <When condition={isEmpty(record?.email_addresses) && onlyAllowUserWithEmailAddress}>
                  <Tooltip title="This user doesn't have an email address, which is why you can't select them.">
                    <Checkbox className="rounded-checkbox" disabled />
                  </Tooltip>
                </When>
                <Otherwise>
                  <Checkbox
                    className="rounded-checkbox"
                    checked={isSelected}
                    disabled={disableSelectedItems && findIndex(selectedItems, (val) => val.id === record.id) > -1}
                  />
                </Otherwise>
              </Choose>
            </div>
          </When>
          <Otherwise>
            <div className="mapper-profile-right-content">
              <FontAwesomeIcon size="lg" className="arc-color-primary" icon={faArrowRight} />
            </div>
          </Otherwise>
        </Choose>
      </If>
      <ThemeXModal
        wrapClassName="vfx-modal-wrapper"
        visible={openVFXModal}
        width={512}
        modalTitle="Verifications"
        handleCancel={toggleVFXModal}>
        <div
          className="p24"
          dangerouslySetInnerHTML={{
            __html: verifications,
          }}
        />
      </ThemeXModal>
    </div>
  );
}

ProfileListItem.propTypes = {
  record: shape({
    is_registered: bool,
    educations: arrayOf(
      shape({
        id: number,
        class_year: number,
      }),
    ),
    role: string,
    profile_url: string,
  }),
  isActionEnabled: bool,
  isVFXEnabled: bool,
  isSelected: bool,
  isMultipleSelectionEnabled: bool,
  disableSelectedItems: bool,
  selectedItems: arrayOf(shape()),
  onlyAllowUserWithEmailAddress: bool,
};
ProfileListItem.defaultProps = {
  record: shape({
    is_registered: false,
    educations: [],
    role: '',
    string: '',
  }),
  isActionEnabled: true,
  isVFXEnabled: false,
  isSelected: false,
  selectedItems: [],
  disableSelectedItems: false,
  isMultipleSelectionEnabled: false,
  onlyAllowUserWithEmailAddress: false,
};
